module.exports = __webpack_public_path__ + "img/black.a78c5e93.webp";